/**
 * Tazty partner portal — shared marketing / auth card design tokens.
 * Org behavior and layout: use `src/config/sellerOrgConfig.ts` + `useSellerOrgConfig()`.
 */

import {
  getSellerOrgBuildConfig,
  getSellerOrgCodeNormalized,
  type SellerOrgCode,
} from "../config/sellerOrgConfig";

export const PARTNER_PRIMARY_HEX = "#006e2f";

/** Lighter green for chips, icon wells, carousel accents. */
export const PARTNER_PRIMARY_CONTAINER_HEX = "#22c55e";

export { getSellerOrgCodeNormalized, getSellerOrgBuildConfig, type SellerOrgCode };

export function isTaztyBuild(): boolean {
  return getSellerOrgBuildConfig().code === "tazty";
}

export function isValarBuild(): boolean {
  return getSellerOrgBuildConfig().code === "valar";
}

export function isMsmeBuild(): boolean {
  return getSellerOrgBuildConfig().code === "msme";
}
